<!--
 * @Author: QWX
 * @Description:对账 付款记录 查看
 * @LastEditors: QWX
 * @LastEditTime: 2021-11-23 17:42:40
-->
<template>
  <zl-dialog class="zl-saas" title="付款记录" ref="dialog" width="560px" :close-on-click-modal="false">
    <el-descriptions title="" :column='1' size="medium">
      <el-descriptions-item label="对账结算单号">{{detailInfo.payCode}}</el-descriptions-item>
      <el-descriptions-item label="对账金额（元）">
        <span class="finalCount">
          <template v-for="(item, index) in accountMoney" >
            <i class="divider" :key="index" v-if="index !== 0"></i>
            <span  :key="index">{{item.money | $zlFiltersMoneyFormat}}</span>{{item.currencyCh}}
          </template>
        </span>
      </el-descriptions-item>
      <el-descriptions-item label="付款方式">{{getValue('payType', detailInfo.payWay)}}</el-descriptions-item>
      <el-descriptions-item label="实际付款金额(元)">
        <span class="finalCount">
          <template v-for="(item, index) in payMoney" >
            <i class="divider" :key="index" v-if="index !== 0"></i>
            <span  :key="index">{{item.money | $zlFiltersMoneyFormat}}</span>{{item.currencyCh}}
          </template>
        </span>
      </el-descriptions-item>
      <el-descriptions-item label="付款说明">
        {{detailInfo.remark}}
      </el-descriptions-item>
      <el-descriptions-item label="已支付的证明附件"><zsFileDownload :fileId="detailInfo.fileId"/></el-descriptions-item>
    </el-descriptions>
  </zl-dialog>
</template>
<script>
import { getValue } from '@/lib/enum'
import store from '@/store/index'
import zsFileDownload from '@/components/zsFileDownload'
export default {
  components: { zsFileDownload },
  data() {
    return {
      getValue,
      detailInfo: {},
      accountMoney: []
    }
  },
  computed: {
    payMoney() {
      return JSON.parse(this.detailInfo.payMoney || '[]')
    }
  },
  methods: {
    open(args) {
      const id = args.id
      this.accountMoney = args.accountMoney
      store.dispatch(args.api || 'getPaymentByPaymentId', {
        paymentId: id
      }).then(res => {
        this.detailInfo = res
      })
      return this.$refs.dialog.open()
    },
    cancel() {
      this.$refs.dialog.cancel()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.zl-saas{
  .el-dialog__body{
   padding-left: 48px;

  }
  .finalCount{
    line-height: 1;
  }
}
</style>
